import React, { useState } from "react";

const ChatIframe = ({ src, width = 350, height = 500 }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => setIsOpen((prev) => !prev);

  return (
    <div className="absolute bottom-4 right-6 z-50 flex flex-col items-end space-y-3">
      {/* Chat Iframe Panel */}
      {isOpen ? (
        <div
          className={`bg-white rounded-xl shadow-2xl overflow-hidden transition-all duration-300 ${
            isOpen
              ? "opacity-100 translate-y-0 pointer-events-auto"
              : "opacity-0 translate-y-4 pointer-events-none"
          }`}
          style={{ width: `${width}px`, height: `${height}px` }}
        >
        
          <SupportWidget/>
        </div>
      ) : null}
      {/* Toggle Button */}
      <button
        onClick={toggleChat}
        className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-indigo-500 to-purple-500 text-white text-2xl rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
        aria-label="Toggle Chat"
      >
        {isOpen ? "✖" : "💬"}
      </button>
    </div>
  );
};


const SupportWidget = ({activeTab, setActiveTab}) => {
    
    
    return (
    <div className="w- rounded-t-xl border border-gray-300 shadow-lg">
      {/* Tabs */}
      <div className="flex">
        <button
          className={`flex-1 py-2 text-center font-medium ${
            activeTab === "chat"
              ? "bg-green-600 text-white"
              : "bg-green-100 text-green-800"
          } rounded-tl-xl`}
          onClick={() =>{
            window.$chatwoot.toggle("open")
            setActiveTab("chat")}}
        >
          Chat with us
        </button>
        <button
          className={`flex-1 py-2 text-center font-medium ${
            activeTab === "bot"
              ? "bg-green-600 text-white"
              : "bg-green-100 text-green-800"
          } rounded-tr-xl`}
        //   onClick={() => setActiveTab("bot")}
        onClick={e=>{
          
        setActiveTab("bot")
        }}
        >
          Bot Assistant
        </button>
      </div>

      {/* Content */}
      <div className="bg-white p-6 text-center">
        <h2 className="text-lg font-semibold mb-4">How can we help you?</h2>
        <div className="space-y-4">
          <button
              onClick={() =>{
                window.$chatwoot.toggle("open")
                setActiveTab("chat")}}
     
          className="w-full border border-green-500 text-green-800 py-2 rounded-md hover:bg-green-50 font-medium">
            Chat with us
          </button>
          <button 
           onClick={e=>setActiveTab("bot")}
     
          className="w-full border border-green-500 text-green-800 py-2 rounded-md hover:bg-green-50 font-medium">
            Bot Assistant
          </button>
        </div>
      </div>
    </div>
  );
};

 export {SupportWidget};

 export default ChatIframe;
